/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react"
import { ProSidebar, Menu, MenuItem, SubMenu } from "./components/ProSidebar"
import { Link } from "react-router-dom"
// import { useLocalstorage } from "./assets/ts/useLocalstorage"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faStar } from "@fortawesome/free-solid-svg-icons"
import { menuIcons } from "./constant/icons"
import { allPages } from "./constant/pages"
import { メニュー分類, 分類リスト } from "./constant/categories"
import util from "./ts/util"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch } from "."
import { getMenu, getMyMenu } from "./globalStore/menuStore"
import { RootState } from "./globalStore/rootreducer"

const SideBar: React.FC<{ collapsed: boolean }> = React.memo((props) => {
  const myPages = useSelector((state: RootState) => state.menu.myPages)
  const pages = useSelector((state: RootState) => state.menu.menuPage)
  const categories = useSelector((state: RootState) => state.menu.categories)

  const dispatch: AppDispatch = useDispatch()
  useEffect(() => {
    dispatch(getMenu())
    dispatch(getMyMenu())
  }, [])

  return (
    <div id="sideBar">
      <ProSidebar collapsed={props.collapsed}>
        <Menu>
          <SubMenu
            defaultOpen={true}
            title="お気に入り"
            key={`大分類_favorite_${0}`}
            icon={<FontAwesomeIcon className="menu-icon" icon={faStar} />}>
            {myPages.length > 0 ? (
              myPages.map((メニュー, i) => {
                const code = メニュー.メニューコード
                const page = allPages.find((p) => p.メニューコード === code)
                if (page == null) return <></>
                const linkPath = util.getDefaultPath(page.Route)
                return (
                  <MenuItem key={`favorite_${code}_${i}`}>
                    <Link to={linkPath}>{page.機能名}</Link>
                  </MenuItem>
                )
              })
            ) : (
              <></>
            )}
          </SubMenu>
          {分類リスト
            .filter((分類) => {
              // 内部のページが存在していない分類は表示しない
              return categories.includes(分類.分類コード)
            })
            .map((分類, i) => {
              // トップだけ別枠表示
              if (分類.分類コード === メニュー分類.トップ) {
                return (
                  <MenuItem
                    key={`分類_${分類.分類コード}_${i}`}
                    icon={<Link to={分類.url}>{menuIcons[分類.icon]}</Link>}>
                    <Link to={分類.url ?? ""}>{分類.分類名}</Link>
                  </MenuItem>
                )
              }
              // 分類対応のページリストを作成
              const pageList = allPages.filter(
                (p) =>
                  p.分類コード === 分類.分類コード &&
                  (p.メニュー表示フラグ ?? true) &&
                  pages.find((ps) => ps.メニューコード === p.メニューコード)
              )
              return (
                <SubMenu
                  defaultOpen={false}
                  LinkedTitle={
                    <>
                      <Link to={分類.url ?? ""}>{分類.分類名}</Link>
                    </>
                  }
                  key={`分類_${分類.分類コード}_${i}`}
                  icon={menuIcons[分類.icon]}>
                  {pageList
                    .filter(
                      (page) =>
                        page != null &&
                        page.Route != null &&
                        page.Route.path != null
                    )
                    .map((page, j) => {
                      let linkPath = util.getDefaultPath(page.Route, "/")

                      return (
                        <MenuItem key={`menu_${page.メニューコード}_${i}_${j}`}>
                          <Link to={linkPath}>{page.機能名}</Link>
                        </MenuItem>
                      )
                    })}
                </SubMenu>
              )
            })}
        </Menu>
      </ProSidebar>
    </div>
  )
})

export default SideBar
